<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-house marker-house-broker map-marker"
            :class="{ active: active === fmLatlng, hidden: data.destroyed || isShowMask }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @touchend="onClick"
            @click="onClick"
            @wheel.stop
            @mousewheel.stop
            v-bind="$attrs"
        >
            <span
                class="marker-shape"
                :class="{ highlight: data.keepHighlight }"
            >
                <template
                    v-if="
                        data.nodisclosureDes ||
                            hidePrice
                    "
                >&#xfe61;&#xfe61;&#xfe61;&#xfe61;&#xfe61;</template>
                <template
                    v-if="
                        !(data.nodisclosureDes ||
                            hidePrice ||
                            isShowMask)
                    "
                >
                    {{ showPrice }}
                </template>
            </span>
            <div
                ref="pop"
                class="marker-pop"
                :class="{ multi: houses.length > 1, bottom: popBottom }"
                :style="popStyle"
            >
                <div class="house-header" v-if="houses.length > 1">
                    <span class="iconfont icon-pinterest"></span>
                    <span>{{
                        $t('md-house.unitesHere', { count: houses.length })
                    }}</span>
                </div>
                <ul class="houst-list">
                    <li
                        class="house-item"
                        v-for="item in houses"
                        :key="item.id"
                    >
                        <a
                            :href="transformLink2WordPress(item.link)"
                            :target="item.detailUrlTarget"
                            rel="noopener noreferrer"
                        >
                            <div class="house-top">
                                <img-box
                                    class="img-container"
                                    :src="item.preview"
                                    :alt="item.address"
                                />
                            </div>
                            <div class="house-bottom">
                                <div class="info">
                                    <p class="price" v-if="hideItemPrice(item)">
                                        Non-Disclosure
                                    </p>
                                    <p
                                        class="price"
                                        v-else-if="!item.nodisclosureDes"
                                    >
                                        {{
                                            showItemSoldPrice(item)
                                                ? item.soldPrice.replace(
                                                    /\s/g,
                                                    ''
                                                )
                                                : item.price.replace(/\s/g, '')
                                        }}
                                    </p>
                                    <p class="price" v-else>
                                        {{ item.nodisclosureDes }}
                                    </p>
                                    <div class="desc">
                                        <span class="desc-span" v-for="it in item.basic" :key="it.key">{{ it.text }}</span>
                                    </div>
                                    <p class="addr" v-if="item.streetAddress">
                                        {{ item.streetAddress }}
                                    </p>
                                </div>
                                <div class="mls">
                                    <p v-if="!isShowMask && item.provided">
                                        {{ item.provided }}
                                    </p>
                                    <site-img
                                        v-if="item.mlsLogo"
                                        :src="item.mlsLogo"
                                        dir="height"
                                    />
                                </div>
                            </div>
                        </a>
                        <house-mask
                            v-if="item.isProtected && !userEmailVerified"
                            :address="item.address"
                        />
                    </li>
                </ul>
            </div>
        </div>
    </Teleport>
</template>
<script>
import Marker from './marker';
import HouseFormat, { getBasic } from '@/common/house';
import HouseMask from '../../../modules/md-house/mask.vue';
import { mapState as rootMapActions } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import { mapState } from '@/store/helpers';
export default {
    mixins: [Marker],
    data: function() {
        return {
            type: 'house',
            markerClassName: 'map-house-wrapper'
        };
    },
    components: {
        HouseMask
    },
    methods: {
        showItemSoldPrice(item) {
            return item.soldDate && item.showSoldPrice
        },
        hideItemPrice(item) {
            return !(this.house.showListingPrice || this.showItemSoldPrice(item)) && item.soldDate
        }
    },
    computed: {
        ...mapState(['result']),
        ...rootMapActions(useUserStore, ['userEmailVerified']),
        ...rootMapActions(usePageStore, { 
            page: 'processedGlobalData' 
        }),
        hidePrice({ house, houses }) {
            return !(house.showListingPrice || houses[0].showSoldPrice) && houses[0].soldDate 
        },
        house({ page }) {
            return page?.house || {};
        },
        isShowMask() {
            let isVerified = this.userEmailVerified;
            return this.houses.length && this.houses[0].isProtected && !isVerified;
        },
        houses() {
            return this.data.items.map(item => {
                let house = HouseFormat.call(this, item, this.page);
                house.basic = getBasic.call(this, item);
                return house;
            });
        }
    }
};
</script>
<style lang="scss">
.marker-house {
    &.hidden{
        display: none;
    }
    .marker-pop {
        .houst-list {
            .house-item {
                .house-top .img-container .img-content > img {
                    height: auto;
                }
                .house-bottom {
                    .info {
                        .addr {
                            padding: 0 10px;
                            font: 12px var(--font-normal);
                            color: var(--g-text-color);
                        }
                    }
                }
            }
        }
    }
}
</style>
